import { render, staticRenderFns } from "./benefitBody.vue?vue&type=template&id=571642eb&"
import script from "./benefitBody.vue?vue&type=script&lang=js&"
export * from "./benefitBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports